import {
    AUTH_REQUEST,
    AUTH_RENEW,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT
  } from "../actions/authentication";

const STORAGE_TOKEN = "STORAGE_TOKEN";
const STORAGE_CURRENT_USER = "STORAGE_CURRENT_USER";

import API from "src/services/Api";
  
const state = { 
    token: localStorage.getItem(STORAGE_TOKEN) || "",
    username: localStorage.getItem(STORAGE_CURRENT_USER) || "",
    status: "",
    hasLoadedOnce: false
};

const getters = {
    isAuthenticated: state => !!state.token,
    token: state => state.token,
    authStatus: state => state.status
};

const actions = {
    [AUTH_REQUEST]: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            API.login(data.username, data.password)
                .then(resp => {
                    resp.data.username = data.username;
                    localStorage.setItem(STORAGE_TOKEN, resp.data.token);
                    localStorage.setItem(STORAGE_CURRENT_USER, resp.data.username);
                    commit(AUTH_SUCCESS, resp);
                    resolve(resp);
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem(STORAGE_TOKEN);
                    reject(err);
                });
        });
    },
    [AUTH_RENEW]: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            API.renewToken(data.token)
                .then(resp=>{
                    if(resp.data.token != null){
                        console.log("Token obtido: "+resp.data.token);
                        localStorage.setItem(STORAGE_TOKEN, resp.data.token);
                        commit(AUTH_RENEW, resp.data);
                        resolve(resp.data.token);
                    }else{
                        commit(AUTH_LOGOUT, null);
                        localStorage.removeItem(STORAGE_TOKEN);
                        reject(null);
                    }
                })
                .catch(err => {
                    commit(AUTH_LOGOUT, err);
                    localStorage.removeItem(STORAGE_TOKEN);
                    reject(err);
                })                    
        })
    },
    [AUTH_LOGOUT]: ({ commit }) => {
        return new Promise(resolve => {
            commit(AUTH_LOGOUT);
            localStorage.removeItem(STORAGE_TOKEN);
            resolve();
        });
    }
}

const mutations = {

    [AUTH_REQUEST]: state => {
        state.status = "loading";
    },

    [AUTH_RENEW]: (state, resp) => {
        state.status = "success";
        state.token = resp.token;
        state.hasLoadedOnce = true;
    },

    [AUTH_SUCCESS]: (state, resp) => {
        state.status = "success";
        state.token = resp.token;
        state.username = resp.username;
        state.hasLoadedOnce = true;
    },

    [AUTH_ERROR]: state => {
        state.status = "error";
        state.hasLoadedOnce = true;
    },

    [AUTH_LOGOUT]: state => {
        state.token = "";
        state.username = "";
    }
};
  
export default {
    state,
    getters,
    actions,
    mutations
};